<template>
    <v-main>
      <!-- <v-container class="fill-height" fluid>
        <v-row align="center" justify="center">
          <v-col cols="12" sm="8" md="5"> -->
            <p class="text-center red--text text-h5 mt-6">Account</p>

            <p class="ma-4 styled-font text-center">Forgot password</p>
            
            <v-card class="elevation-12 mx-auto mt-10" max-width="500" elevation="0"><Alert />
              <v-card-text
                v-if="sent"
              >An email has been sent to you. Go to your email and click on the link to reset your password</v-card-text>
              <!-- <v-toolbar color="primary" dark flat>
                <v-toolbar-title>Forgot Password</v-toolbar-title>
              </v-toolbar> -->
              
              <v-card-text>
                <v-form ref="form" v-model="valid" :lazy-validation="lazy" @keyup.native.enter="sendMail">
                  <v-text-field
                    label="Email"
                    name="email"
                    prepend-icon="mdi-email"
                    type="email"
                    v-model="user.email"
                    v-on:keyup.13="sendMail"
                    :rules="emailRules"
                    required
                    rounded
                    dense
                    outlined
                  />
                </v-form>
              </v-card-text>
              <v-spacer />
              <v-card-actions>
                <v-btn class="buttons" rounded @click="sendMail">Send email</v-btn>
                <v-spacer />
                <router-link to="login">Back to Login</router-link>
              </v-card-actions>
            </v-card>
          <!-- </v-col>
        </v-row>
      </v-container> -->
    </v-main>
</template>

<script>
import Alert from "../templates/Alert"
export default {
  name: "ForgotPassword",
  data: () => ({
    valid: true,
    lazy: false,
    user: {
      email: ""
    },
    sent: false,
    emailRules: [
      v => !!v || "E-mail is required",
      v => /.+@.+\..+/.test(v) || "E-mail must be valid"
    ]
  }),
  components: {
    Alert
  },
  methods: {
    sendMail() {
      if (this.$refs.form.validate()) {
        this.$store
          .dispatch("userauth/aForgotPassword", this.user)
          .then(response => {
            if (response == true) {
              this.sent = true;
            } else {
              //
            }
          });
      }
    },
    close() {
      this.$router.go(-1)
    }
  }
};
</script>

<style>
</style>